export const SUBMIT_ORDER_WRITE = 'SUBMIT_ORDER_WRITE';
export const RESET_ORDER_WRITE = 'RESET_ORDER_WRITE';
export const ORDER_WRITE_SUCCESS = 'ORDER_WRITE_SUCCESS';
export const ORDER_WRITE_FAILURE = 'ORDER_WRITE_FAILURE';
